import { tFunction } from 'app/lang';

import dictionary from './PromocodeForm.dictionary.json';

type ErrorResponseType = keyof typeof getErrorMessageByType;
type ErrorResponseMessage = ReturnType<typeof getErrorMessageByType>;

const getErrorMessageByType = (t: tFunction) => ({
  'code-is-not-started': t(dictionary.notStarted),
  'code-is-expired': t(dictionary.codeIsExpired),
  'code-is-already-activated': t(dictionary.alreadyActivated),
});

function getErrorType(path: string) {
  return path.substring(path.lastIndexOf('/') + 1);
}

function isResponseError(
  param: string,
  errorMessages: ErrorResponseMessage,
) : param is ErrorResponseType {
  return param in errorMessages;
}

export function getErrorMessage(type: string, t: tFunction) {
  const errorType = getErrorType(type);
  const errorMessageByType = getErrorMessageByType(t);
  return isResponseError(errorType, errorMessageByType)
    ? errorMessageByType[errorType]
    : t(dictionary.invalidCode);
}
